import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = {
  key: 0,
  class: "text-md w-full font-semibold"
}
const _hoisted_3 = ["rows"]
const _hoisted_4 = ["rows"]
const _hoisted_5 = {
  key: 4,
  class: "w-full flex-grow flex flex-col h-full my-1"
}
const _hoisted_6 = { class: "w-full flex- text-center flex flex-row justify-around mt-1 pr-12" }
const _hoisted_7 = ["type"]
const _hoisted_8 = ["type"]

import AdditionalDataField from '@/interfaces/additionalData/AdditionalDataField'
import { ref, watch } from 'vue'
import { add, close } from 'ionicons/icons'
import { IonButton, IonButtons, IonIcon, IonSelect, IonSelectOption } from '@ionic/vue'
import { useAddProject } from '@/store/addProject'


export default /*#__PURE__*/_defineComponent({
  __name: 'dynamicInputAdditionalField',
  props: {
    additionalDataField: null,
    showTitle: { type: Boolean },
    subdata: null
  },
  setup(__props: any) {

const props = __props as {
  additionalDataField: AdditionalDataField
  showTitle: boolean
  subdata?: {
    subpath: string
    index: number
  }
}

const addProjectStore = useAddProject()



const type = ref(props.additionalDataField.type)

switch(props.additionalDataField.type) {
  case "datetime": type.value = "datetime-local"; break
  case "float": type.value = 'number'; break
}

watch(() => props.additionalDataField.type, (newValue, oldValue) => {
  let newValueToSave = newValue
  
  switch(newValueToSave) {
    case "datetime": newValueToSave = "datetime-local"; break
    case "float": newValueToSave = 'number'; break
  }
  
  type.value = newValueToSave
})

function generateNewArrayItem(arrayDefinition: AdditionalDataField[]) {
  let object: any = {}
  for(const arrayField of arrayDefinition) object[arrayField.name] = arrayField.default
  return object
}

return (_ctx: any,_cache: any) => {
  const _component_dynamic_input_additional_field = _resolveComponent("dynamic-input-additional-field", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full flex flex-col justify-start", [type.value === 'array' ? 'md:col-span-2' : '']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (props.showTitle)
        ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(props.additionalDataField.prefix) + " " + _toDisplayString(props.additionalDataField.label) + ":" + _toDisplayString(props.additionalDataField.required ? '*' : '') + " " + _toDisplayString(props.additionalDataField.suffix), 1))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonButtons), null, {
        default: _withCtx(() => [
          (type.value === 'array')
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(addProjectStore).projectActiveData.additional_data[props.additionalDataField.name].push(generateNewArrayItem(props.additionalDataField.arrayDefinition!)))),
                style: {"--color":"#444444"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(add) }, null, 8, ["icon"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (type.value === 'select' && props.subdata)
      ? (_openBlock(), _createBlock(_unref(IonSelect), {
          key: 0,
          interface: "popover",
          modelValue: _unref(addProjectStore).projectActiveData.additional_data[props.subdata.subpath][props.subdata.index][props.additionalDataField.name],
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(addProjectStore).projectActiveData.additional_data[props.subdata.subpath][props.subdata.index][props.additionalDataField.name]) = $event)),
          class: "w-full flex-grow min-h-10 h-full bg-zewotherm-lightgrey placeholder-zewotherm-grey p-2 font-bold rounded-lg outline-none my-1"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.additionalDataField.options, (option) => {
              return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                key: option.label,
                value: option.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(option.label), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : (type.value === 'select')
        ? (_openBlock(), _createBlock(_unref(IonSelect), {
            key: 1,
            interface: "popover",
            modelValue: _unref(addProjectStore).projectActiveData.additional_data[props.additionalDataField.name],
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(addProjectStore).projectActiveData.additional_data[props.additionalDataField.name]) = $event)),
            class: "w-full flex-grow min-h-10 h-full bg-zewotherm-lightgrey placeholder-zewotherm-grey p-2 font-bold rounded-lg outline-none my-1"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.additionalDataField.options, (option) => {
                return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                  key: option.label,
                  value: option.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(option.label), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : (type.value === 'textarea' && props.subdata)
          ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
              key: 2,
              class: "w-full flex-grow min-h-10 h-full bg-zewotherm-lightgrey placeholder-zewotherm-grey p-2 font-bold rounded-lg outline-none my-1",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(addProjectStore).projectActiveData.additional_data[props.subdata.subpath][props.subdata.index][props.additionalDataField.name]) = $event)),
              rows: props.additionalDataField.rows!
            }, null, 8, _hoisted_3)), [
              [_vModelText, _unref(addProjectStore).projectActiveData.additional_data[props.subdata.subpath][props.subdata.index][props.additionalDataField.name]]
            ])
          : (type.value === 'textarea')
            ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                key: 3,
                class: "w-full flex-grow min-h-10 h-full bg-zewotherm-lightgrey placeholder-zewotherm-grey p-2 font-bold rounded-lg outline-none my-1",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(addProjectStore).projectActiveData.additional_data[props.additionalDataField.name]) = $event)),
                rows: props.additionalDataField.rows!
              }, null, 8, _hoisted_4)), [
                [_vModelText, _unref(addProjectStore).projectActiveData.additional_data[props.additionalDataField.name]]
              ])
            : (type.value === 'array')
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.additionalDataField.arrayDefinition, (arrayDefinitionField) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: arrayDefinitionField.id,
                        class: "w-0 flex-grow font-semibold text-sm sm:text-base"
                      }, _toDisplayString(arrayDefinitionField.prefix) + " " + _toDisplayString(arrayDefinitionField.shortLabel ? arrayDefinitionField.shortLabel : arrayDefinitionField.label) + _toDisplayString(arrayDefinitionField.required ? '*' : '') + " " + _toDisplayString(arrayDefinitionField.suffix), 1))
                    }), 128))
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addProjectStore).projectActiveData.additional_data[props.additionalDataField.name], (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "w-full flex"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.additionalDataField.arrayDefinition, (arrayDefinitionField) => {
                        return (_openBlock(), _createBlock(_component_dynamic_input_additional_field, {
                          key: arrayDefinitionField.id,
                          "show-title": false,
                          "additional-data-field": arrayDefinitionField,
                          subdata: { subpath: props.additionalDataField.name, index: index },
                          class: "mx-2 first:ml-0 w-0 flex-grow"
                        }, null, 8, ["additional-data-field", "subdata"]))
                      }), 128)),
                      _createVNode(_unref(IonButtons), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            style: {"--color":"#444444"},
                            class: "w-10 ml-2",
                            onClick: ($event: any) => (_unref(addProjectStore).projectActiveData.additional_data[props.additionalDataField.name].splice(index, 1))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), { icon: _unref(close) }, null, 8, ["icon"])
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128))
                ], 512)), [
                  [_vShow, _unref(addProjectStore).projectActiveData.additional_data[props.additionalDataField.name] && _unref(addProjectStore).projectActiveData.additional_data[props.additionalDataField.name].length > 0]
                ])
              : (props.subdata !== undefined)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 5,
                    type: type.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(addProjectStore).projectActiveData.additional_data[props.subdata.subpath][props.subdata.index][props.additionalDataField.name]) = $event)),
                    class: _normalizeClass([[type.value === 'checkbox' ? 'w-7 h-7' : 'w-full h-full min-h-10'], "bg-zewotherm-lightgrey placeholder-zewotherm-grey p-2 font-bold rounded-lg outline-none my-1"])
                  }, null, 10, _hoisted_7)), [
                    [_vModelDynamic, _unref(addProjectStore).projectActiveData.additional_data[props.subdata.subpath][props.subdata.index][props.additionalDataField.name]]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 6,
                    type: type.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(addProjectStore).projectActiveData.additional_data[props.additionalDataField.name]) = $event)),
                    class: _normalizeClass([[type.value === 'checkbox' ? 'w-7 h-7' : 'w-full h-full min-h-10'], "bg-zewotherm-lightgrey placeholder-zewotherm-grey p-2 font-bold rounded-lg outline-none my-1"])
                  }, null, 10, _hoisted_8)), [
                    [_vModelDynamic, _unref(addProjectStore).projectActiveData.additional_data[props.additionalDataField.name]]
                  ])
  ], 2))
}
}

})